(function () {
  'use strict';

  var FREE_PRINT_VARIANT_ID = 44121503727750;
  var FREE_PRINT_PRODUCT_ID = '7639696834694';
  var APPAREL_TYPES = ['T-SHIRT', 'HOODIE', 'SWEATSHIRT'];
  var syncing = false;

  function hasApparel(items) {
    return items.some(function (i) {
      return APPAREL_TYPES.indexOf((i.product_type || '').toUpperCase()) >= 0;
    });
  }

  function freePrintInCart(items) {
    return items.some(function (i) {
      return i.variant_id === FREE_PRINT_VARIANT_ID;
    });
  }

  function syncFreePrint() {
    if (syncing) return;
    syncing = true;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var needsPrint = hasApparel(items);
        var hasPrint   = freePrintInCart(items);

        if (needsPrint && !hasPrint) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: FREE_PRINT_VARIANT_ID, quantity: 1 })
          })
          .then(function (r) {
            if (!r.ok) {
              return r.json().then(function (err) {
                console.warn('[mz-free-print] /cart/add.js rejected — product may be DRAFT:', err);
              });
            }
            return r.json().then(function () { refreshCartUI(); });
          });

        } else if (!needsPrint && hasPrint) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: FREE_PRINT_VARIANT_ID, quantity: 0 })
          })
          .then(function (r) { return r.json(); })
          .then(function () { refreshCartUI(); });
        }
      })
      .then(function () {
        syncing = false;
        decorateFreePrintItems();
      })
      .catch(function (err) {
        syncing = false;
        console.warn('[mz-free-print] sync error', err);
      });
  }

  function refreshCartUI() {
    if (typeof window.refreshCart === 'function') {
      window.refreshCart();
    }
  }

  function decorateFreePrintItems() {
    document
      .querySelectorAll('.cart-item[data-product-id="' + FREE_PRINT_PRODUCT_ID + '"]')
      .forEach(function (el) {
        if (el.dataset.mzFreePrint) return;
        el.dataset.mzFreePrint = 'true';
        var content = el.querySelector('.content');
        if (content && !content.querySelector('.mz-free-print-badge')) {
          var badge = document.createElement('span');
          badge.className = 'mz-free-print-badge';
          badge.textContent = '? Free Gift';
          var firstLink = content.querySelector('a');
          if (firstLink && firstLink.nextSibling) {
            content.insertBefore(badge, firstLink.nextSibling);
          } else {
            content.appendChild(badge);
          }
        }
      });
  }

  document.addEventListener('click', function (e) {
    var node = e.target;
    while (node && node !== document) {
      if (node.classList && node.classList.contains('remove')) {
        var item = node.closest
          ? node.closest('[data-product-id="' + FREE_PRINT_PRODUCT_ID + '"]')
          : null;
        if (item) {
          e.preventDefault();
          e.stopImmediatePropagation();
          item.classList.add('mz-shake');
          setTimeout(function () { item.classList.remove('mz-shake'); }, 700);
        }
        break;
      }
      node = node.parentNode;
    }
  }, true);

  if (!window.__mzFreePrintPatched) {
    window.__mzFreePrintPatched = true;
    var origFetch = window.fetch;
    window.fetch = function (resource, options) {
      var url = typeof resource === 'string'
        ? resource
        : (resource && resource.url ? resource.url : '');
      var result = origFetch.apply(this, arguments);
      if (
        url &&
        (url.indexOf('/cart/add') !== -1 ||
         url.indexOf('/cart/change') !== -1 ||
         url.indexOf('/cart/update') !== -1)
      ) {
        result.then(function (res) {
          if (res && res.ok) {
            setTimeout(syncFreePrint, 450);
          }
          return res;
        }).catch(function () {});
      }
      return result;
    };
  }

  function observeCartItems() {
    var cartHolder = document.getElementById('AjaxCartForm');
    if (!cartHolder) return;
    new MutationObserver(function () {
      decorateFreePrintItems();
    }).observe(cartHolder, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      syncFreePrint();
      observeCartItems();
    });
  } else {
    syncFreePrint();
    observeCartItems();
  }

}());